{
  "CSAT": {
    "TITLE": "Ocijenite razgovor",
    "PLACEHOLDER": "Recite nam više...",
    "RATINGS": {
      "POOR": "😞 Loše",
      "FAIR": "😑 Zadovoljavajuće",
      "AVERAGE": "😐 Prosječno",
      "GOOD": "😀 Dobro",
      "EXCELLENT": "😍 Izvrsno"
    }
  }
}
